<template>
    <div class="ma-4">
        <v-layout row wrap>
            <v-flex xs12 md2 class="pa-1 mb-2">
                <v-menu
                    ref="dateFilterMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateFilter"
                            label="Filter by Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable
                            :disabled="isLoadingDateFilterTable"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="dateFilter"
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="dateFilterMenu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="getUserAuthLogs()"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-flex>

            <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                    label="Select a User"
                    :items="users"
                    item-text="Name"
                    item-value="_id"
                    v-model="userIdFilter"
                    clearable
                    @change="getUserAuthLogs"
                ></v-select>
            </v-flex>

            <v-flex xs12 md2 class="pa-1 mt-3">
                <v-btn v-if="userRole === 'Administration'" color="#2b3990" dark class="mb-2 ml-2" @click="showDeleteDialog = true">
                    Delete User Logs
                </v-btn>
            </v-flex>
        </v-layout>

        <v-dialog v-model="showDeleteDialog" max-width="600px">
            <v-card>
                <v-card-title>Delete Notifications</v-card-title>
                <v-card-text>
                    <v-form>
                        <v-row>
                            <v-col cols="6">
                                <v-card-title>From</v-card-title>
                                <v-date-picker v-model="startDate" label="Start Date"></v-date-picker>
                            </v-col>
                            <v-col cols="6">
                                <v-card-title>To</v-card-title>
                                <v-date-picker v-model="endDate" label="End Date"></v-date-picker>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="showDeleteDialog = false">Cancel</v-btn>
                    <v-btn color="error" text @click="deleteUserAuthLogs">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table
            :page="page"
            :pageCount="pageCount"
            :server-items-length="itemCount"
            :options.sync="options"
            fixed-header
            height="550px"
            width="600"
            class="mx-auto"
            :headers="userAuthLogListHeaders"
            :items="userAuthLogList"
            :loading="isLoadingDateFilterTable"
        >

            <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="item in items" :key="item._id">
                    <td>{{ item.user.Name }}</td>
                    <td>{{ item.type }}</td>
                    <td>{{ item.date }}</td>
<!--                    <td>-->
<!--                        <template v-if="item.clients && item.clients.length">-->
<!--                            {{ item.clients.map(client => client.Name).join(', ') }}-->
<!--                        </template>-->
<!--                        <template v-else>-->
<!--                            No client/s-->
<!--                        </template>-->
<!--                    </td>-->
<!--                    <td>{{ item.device }}</td>-->
<!--                    <td>{{ item.browser }}</td>-->
<!--                    <td>{{ item.os }}</td>-->
                </tr>
                </tbody>
            </template>
        </v-data-table>
        <Foot/>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment';
import Foot from '../components/Footer'
import DateTimeUtil from "../../utils/date-time.util";
import Swal from "sweetalert2";

const url = require("../client_config/config").url;


export default {
    components: {
        Foot,
    },
    data: function () {
        return {
            dateFilterMenu: false,
            dateFilter: moment(new Date()).format("YYYY-MM-DD"),
            isLoadingDateFilterTable: false,
            userAuthLogList: [],
            users: [],
            userIdFilter: '',
            userState: localStorage.getItem('userState'),
            userAuthLogListHeaders: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: true,
                    value: 'user.Name',
                    filterable: false,
                },
                {text: 'Type', value: 'type'},
                {text: 'Date', value: 'date'},
                // {text: 'Client', value: 'clients.Name'},
                // {text: 'Device', value: 'device', filterable: false,},
                // {text: 'Browser', value: 'browser', filterable: false,},
                // {text: 'OS', value: 'os', filterable: false,},
            ],
            page: 1,
            pageCount: 1,
            itemCount: 0,
            options: {},
            userRole: localStorage.getItem('userRole'),
            showDeleteDialog: false,
            startDate: null,
            endDate: null,
            dateRange: null
        };
    },
    computed: {},

    watch: {
        options: {
            handler() {
                this.getUserAuthLogs();
            },
            deep: true
        },
    },

    created() {
        this.getUserAuthLogs();
        this.getUserAuthLogsDistinctUsers();
    },

    methods: {
        async getUserAuthLogs() {
            this.isLoadingDateFilterTable = true;

            let {page, itemsPerPage} = this.options;
            page = page || 1;
            itemsPerPage = itemsPerPage || 10;

            const filterDate = this.dateFilter ? new Date(this.dateFilter) : new Date();
            const startDate = new Date(filterDate);
            startDate.setHours(0, 0, 0, 0);

            const endDate = new Date(filterDate);
            endDate.setHours(23, 59, 59, 999);

            const utcStartDate = DateTimeUtil.toUTCISOString(startDate);
            const utcEndDate = DateTimeUtil.toUTCISOString(endDate);

            const params = {
                page: page,
                limit: itemsPerPage,
                startDate: utcStartDate,
                endDate: utcEndDate,
                userId: this.userIdFilter
            };
            const response = await axios.get(`${url}/user-auth-logs`, {params})

            const {docs, totalPages, totalDocs} = response.data;
            this.pageCount = totalPages;
            this.itemCount = totalDocs;

            this.userAuthLogList = docs.map(userLogs => {
                return {
                    ...userLogs,
                    date: DateTimeUtil.toLocalDateTime(userLogs.date)
                };
            });

            this.isLoadingDateFilterTable = false;
        },

        async getUserAuthLogsDistinctUsers() {
            const response = await axios.get(`${url}/user-auth-logs/users/distinct`);
            this.users = response.data;
        },

        deleteUserAuthLogs() {
            if (confirm("Are you sure you want to delete these user authentication logs?")) {
                const isoStartDate = DateTimeUtil.toUTCISOString(this.startDate);
                const isoEndDate = DateTimeUtil.toUTCISOString(this.endDate);

                Swal.fire({
                    title: 'Please wait',
                    text: 'Deleting user auth logs...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                });

                axios.delete(`${url}/user-auth-logs/delete`, {
                    data: {
                        isoStartDate,
                        isoEndDate
                    }
                })
                    .then(response => {
                        console.log(response.data.message);
                        Swal.close();

                        Swal.fire({
                            title: 'Success!',
                            text: response.data.message,
                            icon: 'success'
                        }).then(() => {
                            location.reload();
                        });
                    })
                    .catch(error => {
                        console.error(error);
                        Swal.close();

                        Swal.fire({
                            title: 'Error!',
                            text: 'An error occurred while deleting notifications.',
                            icon: 'error'
                        });
                    });
            }

            this.showDeleteDialog = false;
        }

    },

};

</script>
